import db from 'utils/localstorage'

export default {
  namespaced: true,
  state: {
    sidebar: {
      opened: true
    },
    settingBar: {
      opened: false
    },
    isMobile: false,
    theme: db.get('THEME', 'light'),
    layout: db.get('LAYOUT', 'side'),
    //systemName: '时光艺站',
    //copyright: `<p style="color: #696969">${new Date().getFullYear()} 广州圣兰科技有限公司 备案号：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2023155206号</a></p>`,
    systemName: '焦糖映画',
    copyright: `<p style="color: #696969">${new Date().getFullYear()} 焦糖映画（广州）科技有限公司 备案号：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2025458937号</a></p>`,
    multipage: getBooleanValue(db.get('MULTIPAGE'), true),
    fixSiderbar: getBooleanValue(db.get('FIX_SIDERBAR'), true),
    fixHeader: getBooleanValue(db.get('FIX_HEADER'), true),
    colorList: [
      'rgb(245, 34, 45)',
      'rgb(250, 84, 28)',
      'rgb(250, 173, 20)',
      'rgb(66, 185, 131)',
      'rgb(82, 196, 26)',
      'rgb(24, 144, 255)',
      'rgb(47, 84, 235)',
      'rgb(114, 46, 209)'
    ],
    color: db.get('COLOR', 'rgb(24, 144, 255)'),
    currency: db.get('CURRENCY', '¥'),
    timezone: localStorage.getItem('timezone') || 'Asia/Shanghai'
  },
  mutations: {
    setDevice (state, isMobile) {
      // [layout-probe] 临时探针
      console.info('[layout-probe] store setDevice', isMobile, 'innerWidth=', window.innerWidth)
      state.isMobile = isMobile
    },
    setTheme (state, theme) {
      db.save('THEME', theme)
      state.theme = theme
    },
    setLayout (state, layout) {
      db.save('LAYOUT', layout)
      state.layout = layout
    },
    setMultipage (state, multipage) {
      db.save('MULTIPAGE', multipage)
      state.multipage = multipage
    },
    setSidebar (state, type) {
      // [layout-probe] 临时探针：打印调用栈以定位触发源
      console.info('[layout-probe] store setSidebar', type, new Error().stack)
      state.sidebar.opened = type
    },
    fixSiderbar (state, flag) {
      db.save('FIX_SIDERBAR', flag)
      state.fixSiderbar = flag
    },
    fixHeader (state, flag) {
      db.save('FIX_HEADER', flag)
      state.fixHeader = flag
    },
    setSettingBar (state, flag) {
      state.settingBar.opened = flag
    },
    setColor (state, color) {
      db.save('COLOR', color)
      state.color = color
    },
    setCurrency (state, currency) {
      db.save('CURRENCY', currency)
      state.currency = currency
    },
    setTimezone (state, timezone) {
      localStorage.setItem('timezone', timezone)
      state.timezone = timezone
    }
  }
}

function getBooleanValue (value, defaultValue) {
  if (Object.is(value, null)) {
    return defaultValue
  }
  if (JSON.stringify(value) !== '{}') {
    return value
  } else {
    return false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js